import React from 'react';
import { LandingUS } from './pages/LandingUS';
// Root path (/*) now shows the US landing page directly.
export function App() {
  return <LandingUS data-id="element-0" />;
}